let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ftzT3")).then(() => parcelRequire('ei6Pl'));